// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__26Mzd","selected":"Chip_selected__1oDwz"};